import React from 'react';
import {Link} from 'gatsby';

// Bootstrap
import {Container, Row, Col} from 'react-bootstrap';

// Components
import FooterIcon from './footer-icon/FooterIcon';

// Less
import './Footer.less';

// Assets
import logo from '../../../../static/assets/brand/logo-white.png';
import facebookIcon from '../../../../static/assets/footer/btn-white-facebook.png';
import linkedinIcon from '../../../../static/assets/footer/btn-white-linkedin.png';
import youtubeIcon from '../../../../static/assets/footer/btn-youtube-white.png';

const Footer = () => (
  <footer className="footer">
    <Container className="footer__container">
      <Row className="footer__row">
        <Col md={3} className="footer__ensembleCredits">
          <img src={logo} alt="logo" />
          <p>
            © {new Date().getFullYear()}
            &nbsp;Ensemble Software SRL |
            <a href="http://ensemblesoftware.ro">ensemblesoftware.ro</a>
          </p>
        </Col>
        <Col md={5}>
          <Row>
            <Col md={6} className='first-address'>
              <address>
              Baia Mare Office
                <br />
                31 Gheorghe Sincai Street
                <br />
                Baia Mare, 430311
                <br />
                Romania
              </address>
            </Col>
            <Col md={6} className='pl-md-5'>
            <address>
              Brasov Office
              <br />
              17E Harmanului Street
              <br />
              Brașov, 500222
              <br />
              Romania
            </address>
            </Col>
          </Row>
        </Col>
        <Col md={2} className="footer__phoneNumber">
          <div>
            <a href="+40745817758">
              <span>&#9742;</span>
              +40 745 817 758
            </a>
          </div>
        </Col>
        <Col md={2} className="footer__links text-left">
          <FooterIcon
            href="https://www.youtube.com/channel/UC7w_YtDQ9ldaCkEbDmz7Hqg/featured"
            src={youtubeIcon}
            alt="Youtube Icon"
          />
          <FooterIcon
            href="https://www.linkedin.com/company/ensemble-software/"
            src={linkedinIcon}
            alt="Linkedin Icon"
          />
          <FooterIcon
            href="https://www.facebook.com/Ensemble-Software-Romania-2180905508855252/"
            src={facebookIcon}
            alt="Facebook Icon"
          />
          <br />
          <Link to="/privacy">Privacy Policy</Link>
          <br />
          <Link to="/cookies">Cookie Policy</Link>
          <br />
          <Link to="/terms">Terms of Use</Link>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;
